var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FDD506"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32102 13.9404C7.99534 13.6164 8.18548 13.0596 8.64129 13.0025L13.2465 12.4258C13.4271 12.4031 13.585 12.2928 13.6682 12.1309L15.7762 8.03305C15.9843 7.6285 16.5652 7.63591 16.7629 8.04563L18.7823 12.2303C18.8605 12.3923 19.0128 12.506 19.1903 12.5349L23.7965 13.284C24.2482 13.3575 24.4189 13.9176 24.0848 14.2305L20.7238 17.3786C20.5899 17.5039 20.5272 17.6877 20.5564 17.8687L21.2898 22.4151C21.3627 22.8669 20.8851 23.2057 20.4828 22.9875L16.3805 20.7627C16.2224 20.677 16.0324 20.6737 15.8715 20.7541L11.7143 22.8295C11.3073 23.0327 10.8432 22.6833 10.926 22.236L11.7648 17.7047C11.798 17.5257 11.7406 17.3418 11.6115 17.2135L8.32102 13.9404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularStarIcon);
export default __webpack_public_path__ + "static/media/circular-star-icon.b120aeae43a042089836143fd1e0bcce.svg";
export { ForwardRef as ReactComponent };